/* ===== FREE GIFT WITH PURCHASE =====
   1. When a product with a data-free-gift marker is added, each of its gift
      variants (one or two) is added once, tagged with a hidden _free_gift_for property.
   2. When the basket changes:
      - only 1 of each tagged gift is kept per main product; extra units the
        customer adds are moved to a normal full-price line
      - if the main product is removed, its free units are removed, and any
        paid extras stay as a normal purchase
   Untagged items (normal purchases of the same product) are never removed.
   Works alongside Warehouse's own cart code without changing it. */
(function () {
  if (window.__freeGiftInstalled) return;
  window.__freeGiftInstalled = true;

  var originalFetch = window.fetch.bind(window);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var GIFT_PROP = '_free_gift_for';
  var JSON_HEADERS = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

  function post(path, payload) {
    return originalFetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: JSON_HEADERS,
      body: JSON.stringify(payload)
    });
  }

  function getCart() {
    return originalFetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function isTagged(item) {
    return !!(item.properties && item.properties[GIFT_PROP]);
  }

  function findMarker(variantId) {
    if (!variantId) return null;
    var markers = document.querySelectorAll('[data-free-gift]');
    for (var i = 0; i < markers.length; i++) {
      var variants = (markers[i].getAttribute('data-variants') || '').split(',');
      if (variants.indexOf(String(variantId)) !== -1) return markers[i];
    }
    return null;
  }

  /* ---------- Adding the gifts ---------- */
  function addGiftsIfMissing(marker, mainId) {
    var productId = marker.getAttribute('data-product');
    var giftIds = (marker.getAttribute('data-gift') || '').split(',').filter(function (id) {
      return id && String(id) !== String(mainId);
    });
    if (!giftIds.length) return Promise.resolve();

    return getCart().then(function (cart) {
      var missing = giftIds.filter(function (giftId) {
        return !cart.items.some(function (item) {
          return String(item.variant_id) === String(giftId);
        });
      });
      var props = {};
      props[GIFT_PROP] = String(productId);

      /* one at a time, so one failing (e.g. just sold out) can't block the other */
      return missing.reduce(function (chain, giftId) {
        return chain.then(function () {
          return post('cart/add.js', { items: [{ id: Number(giftId), quantity: 1, properties: props }] })
            .catch(function () {});
        });
      }, Promise.resolve());
    }).catch(function () {});
  }

  /* ---------- Tidying the basket ---------- */
  function giftGroups(cart) {
    var groups = {};
    cart.items.forEach(function (item, index) {
      if (!isTagged(item)) return;
      var forProduct = String(item.properties[GIFT_PROP]);
      var id = item.variant_id + ':' + forProduct;
      if (!groups[id]) {
        groups[id] = { variantId: item.variant_id, forProduct: forProduct, total: 0, firstLine: index + 1, firstQty: item.quantity };
      }
      groups[id].total += item.quantity;
    });

    return Object.keys(groups).map(function (k) {
      var g = groups[k];
      g.mainPresent = cart.items.some(function (other) {
        return String(other.product_id) === g.forProduct && !isTagged(other);
      });
      g.keepTagged = g.mainPresent ? 1 : 0;
      return g;
    }).filter(function (g) { return g.total > g.keepTagged; });
  }

  /* Fixes gift groups one after another. Resolves with the last cart response
     (so the drawer redraws correctly), or null if nothing needed changing. */
  function tidy(cart, extra, depth) {
    depth = depth || 0;
    if (!cart || !cart.items || depth > 3) return Promise.resolve(null);
    var groups = giftGroups(cart);
    if (!groups.length) return Promise.resolve(null);

    var target = groups[0];
    var paidExtras = target.total - 1; /* only one unit was ever free */

    function sameGroup(g) {
      return g.variantId === target.variantId && g.forProduct === target.forProduct;
    }

    function shrink(currentCart, lastRes, guard) {
      var current = giftGroups(currentCart).filter(sameGroup)[0];
      if (!current || guard > 5) return Promise.resolve(lastRes);
      var excess = current.total - current.keepTagged;
      var newQty = Math.max(0, current.firstQty - excess);
      return post('cart/change.js', Object.assign({ line: current.firstLine, quantity: newQty }, extra))
        .then(function (res) {
          if (!res.ok) return lastRes;
          return res.clone().json().then(function (c) { return shrink(c, res, guard + 1); });
        });
    }

    return shrink(cart, null, 0).then(function (lastRes) {
      if (paidExtras < 1) return lastRes;
      return post('cart/add.js', { items: [{ id: target.variantId, quantity: paidExtras }] })
        .then(function () { return getCart(); })
        .then(function (c) {
          if (!c.items.length) return lastRes;
          return post('cart/change.js', Object.assign({ line: 1, quantity: c.items[0].quantity }, extra));
        });
    }).then(function (res) {
      /* another gift group may still need fixing (e.g. two gifts left behind) */
      return getCart().then(function (c) {
        return tidy(c, extra, depth + 1).then(function (next) { return next || res; });
      });
    }).catch(function () { return null; });
  }

  /* ---------- Watching Warehouse's cart requests ---------- */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    var isChange = /\/cart\/(change|update)(\.js)?(\?|$)/.test(url);
    if (!init || (!isAdd && !isChange)) return originalFetch(input, init);

    var body = null;
    if (typeof init.body === 'string') {
      try { body = JSON.parse(init.body); } catch (e) {}
    }

    if (isAdd) {
      var mainId = body && (body.id || (body.items && body.items[0] && body.items[0].id));
      var marker = findMarker(mainId);
      if (!marker) return originalFetch(input, init);

      return originalFetch(input, init).then(function (response) {
        if (!response.ok) return response;
        return addGiftsIfMissing(marker, mainId).then(function () { return response; });
      });
    }

    var extra = {};
    if (body && body.sections) extra.sections = body.sections;
    if (body && body.sections_url) extra.sections_url = body.sections_url;

    return originalFetch(input, init).then(function (response) {
      if (!response.ok) return response;
      return response.clone().json().then(function (cart) {
        return tidy(cart, extra).then(function (fixed) { return fixed || response; });
      }).catch(function () { return response; });
    });
  };

  /* ---------- Basket page mode (in case the setting is ever switched) ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!window.theme || window.theme.cartType !== 'page') return;
    var idInput = form.querySelector('[name="id"]');
    var mainId = idInput && idInput.value;
    var marker = findMarker(mainId);
    if (!marker) return;

    event.preventDefault();
    originalFetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function (response) {
      if (!response.ok) { form.submit(); return; }
      return addGiftsIfMissing(marker, mainId).then(function () {
        window.location.href = root + 'cart';
      });
    });
  });

  /* ---------- Basket page: tidy on load ---------- */
  if (/\/cart\/?$/.test(window.location.pathname)) {
    getCart().then(function (cart) {
      return tidy(cart, {});
    }).then(function (fixed) {
      if (fixed) window.location.reload();
    }).catch(function () {});
  }
})();
/* ===== END FREE GIFT WITH PURCHASE ===== */